export default __webpack_public_path__ + "static/media/section3_3_1.15083def.png";